module.exports = __webpack_public_path__ + "static/media/workPvcCeilings16.82bea911.jpg";